import { useQuery } from '@tanstack/react-query';

import { fetchShipmentSortingFieldsList } from '../data-provider/shipment-sorting-fields-list';

export const useGetShipmentSortingFields = () => {
  return useQuery({
    queryFn: () => fetchShipmentSortingFieldsList(),
    queryKey: ['shipment-sorting-fields'],
    // biome-ignore lint/style/noMagicNumbers: 1 day
    staleTime: 1000 * 60 * 60 * 24,
  });
};
